<template>
    <v-container fluid>
        <template v-if="!data">
            <skeleton />
        </template>
        <template v-else>
            <v-row class="justify-center">
                <v-col cols="12" sm="12" xs="12" md="12" lg="6">
                    <indicator-group
                        :label="$t('dashboard.partners')"
                        icon="mdi-account-tie"
                    >
                        <circle-indicator
                            :value="data.totals.resellers"
                            label="Total"
                        />
                        <circle-indicator
                            v-for="(item, index) in data.byType"
                            :key="'reselers-byType-' + index"
                            :value="item.resellers"
                            :leftDivider="true"
                            :label="index"
                            color="indigo"
                        />
                    </indicator-group>
                </v-col>

                <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <indicator-group
                        label="Positivação do Canal"
                        icon="mdi-speedometer"
                    >
                        <semi-circle-gauge
                            :value="data.totals.resellersEngagement"
                        />
                    </indicator-group>
                </v-col>

                <v-col cols="12" sm="6" xs="12" md="6" lg="4">
                    <indicator-group
                        :label="
                            $t('dashboard.pending-cancellation-requisitions')
                        "
                        icon="mdi-alert-octagon"
                    >
                        <circle-indicator
                            color="red darken-2"
                            :label="
                                $t(
                                    'dashboard.pending-cancellation-requisitions',
                                )
                            "
                            :value="data.totals.pendingCancellationRequisition"
                        />
                    </indicator-group>
                </v-col>

                <v-col cols="12" sm="6" xs="12" md="6" lg="4">
                    <indicator-group
                        :label="$t('dashboard.partners-without-activation')"
                        icon="mdi-account-tie-voice-off"
                    >
                        <circle-indicator
                            :value="data.totals.lastActivationNinetyDays"
                            :label="
                                $t('dashboard.partners-without-activation-text')
                            "
                            :routerLink="{
                                name: $t('partner.routes.index'),
                                params: {
                                    tabStatusToActive:
                                        'lastActivationNinetyDays',
                                },
                            }"
                            color="red"
                        />
                    </indicator-group>
                </v-col>

                <v-col cols="12" sm="6" xs="12" md="6" lg="4">
                    <indicator-group
                        :label="$t('dashboard.internal-users')"
                        icon="mdi-account-hard-hat"
                    >
                        <circle-indicator
                            color="teal"
                            :label="$t('dashboard.internal-users')"
                            :value="data.totals.internalUsers"
                        />
                    </indicator-group>
                </v-col>
            </v-row>

            <v-row>
                <!-- CUSTOMERS ACTIVATIONs -->
                <v-col sm="12" md="6">
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon>
                                mdi-account-check
                            </v-icon>
                            {{ $t('dashboard.customers-active') }}

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small v-bind="attrs" v-on="on"
                                        >mdi-information</v-icon
                                    >
                                </template>

                                <span>{{
                                    $t('dashboard.hints.with-blocked')
                                }}</span>
                            </v-tooltip>
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                icon="mdi-account-group-outline"
                                label="Total"
                                :value="data.totals.active"
                                :sub="$n(data.totals.activeValue, 'currency')"
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'active-customers-byType-' + index"
                                icon="mdi-account-box-outline"
                                :label="index"
                                :value="item.active"
                                :sub="$n(item.activeValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- /CUSTOMERS ACTIVATIONS -->

                <!-- CUSTOMERS ON MONTH ACTIVATIONS -->
                <v-col sm="12" md="6">
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon>
                                mdi-account-check
                            </v-icon>
                            {{ $t('dashboard.customers-active-month') }}
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small v-bind="attrs" v-on="on"
                                        >mdi-information</v-icon
                                    >
                                </template>

                                <span>{{
                                    $t('dashboard.hints.with-blocked')
                                }}</span>
                            </v-tooltip>
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                icon="mdi-account-group"
                                label="Total"
                                :value="data.totals.activeMonth"
                                :sub="
                                    $n(data.totals.activeMonthValue, 'currency')
                                "
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'active-month-customers-byType-' + index"
                                icon="mdi-account-box-outline"
                                :label="index"
                                :value="item.activeMonth"
                                :sub="$n(item.activeMonthValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- /CUSTOMERS ON MONTH ACTIVATIONS -->
            </v-row>

            <!-- BLOQUEADOS INICIO -->
            <v-row>
                <v-col>
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon left>
                                mdi-account-cancel
                            </v-icon>
                            {{ $t('dashboard.customers-blocked') }}
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                label="Total"
                                :value="data.totals.blocked"
                                :sub="$n(data.totals.blockedValue, 'currency')"
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'blocked-customers' + index"
                                :label="index"
                                :value="item.blocked"
                                :sub="$n(item.blockedValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col>
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon left>
                                mdi-account-cancel
                            </v-icon>
                            {{ $t('dashboard.customers-blocked-month') }}
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                label="Total"
                                :value="data.totals.blockedMonth"
                                :sub="
                                    $n(
                                        data.totals.blockedMonthValue,
                                        'currency',
                                    )
                                "
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'blocked-customers' + index"
                                :label="index"
                                :value="item.blockedMonth"
                                :sub="$n(item.blockedMonthValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <!-- BLOQUEADOS FIM -->

            <!-- CANCELADOS INICIO -->
            <v-row>
                <v-col>
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon left>
                                mdi-account-multiple-remove
                            </v-icon>
                            {{ $t('dashboard.customers-canceled') }}
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                label="Total"
                                :value="data.totals.canceled"
                                :sub="$n(data.totals.canceledValue, 'currency')"
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'canceled-customers' + index"
                                :label="index"
                                :value="item.canceled"
                                :sub="$n(item.canceledValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col>
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon left>
                                mdi-account-multiple-remove
                            </v-icon>
                            {{ $t('dashboard.customers-canceled-month') }}
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                label="Total"
                                :value="data.totals.canceledMonth"
                                :sub="
                                    $n(
                                        data.totals.canceledMonthValue,
                                        'currency',
                                    )
                                "
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'blocked-customers' + index"
                                :label="index"
                                :value="item.canceledMonth"
                                :sub="$n(item.canceledMonthValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <!-- CANCELADOS FIM -->

            <!-- VENDAS INICIO -->
            <v-row>
                <v-col>
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon left>
                                mdi-cart
                            </v-icon>
                            {{ $t('dashboard.product-sales') }}
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                label="Total"
                                :value="data.totals.productSales"
                                :sub="
                                    $n(
                                        data.totals.productSalesValue,
                                        'currency',
                                    )
                                "
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'product-sales' + index"
                                :label="index"
                                :value="item.productSales"
                                :sub="$n(item.productSalesValue, 'currency')"
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col>
                    <v-card class="text-no-wrap">
                        <div class="overline pl-3 pt-3">
                            <v-icon left>
                                mdi-cart
                            </v-icon>
                            {{ $t('dashboard.product-sales-month') }}
                        </div>
                        <v-card-text class="d-flex justify-space-around">
                            <plain-indicator
                                label="Total"
                                :value="data.totals.productSalesMonth"
                                :sub="
                                    $n(
                                        data.totals.productSalesValueMonth,
                                        'currency',
                                    )
                                "
                            />
                            <plain-indicator
                                v-for="(item, index) in data.byType"
                                :key="'product-sales-month' + index"
                                :label="index"
                                :value="item.productSalesMonth"
                                :sub="
                                    $n(item.productSalesValueMonth, 'currency')
                                "
                                color="green-blue"
                                :leftDivider="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <!-- VENDAS FIM -->
        </template>
    </v-container>
</template>

<script>
import skeleton from './Skeleton'
import CircleIndicator from '@/components/indicators/CircleIndicator'
import PlainIndicator from '@/components/indicators/PlainIndicator'
import IndicatorGroup from '@/components/indicators/IndicatorGroup'
import SemiCircleGauge from '@/components/indicators/SemiCircleGauge'

export default {
    components: {
        skeleton,
        'circle-indicator': CircleIndicator,
        'plain-indicator': PlainIndicator,
        IndicatorGroup,
        SemiCircleGauge,
    },

    data: () => {
        return {
            data: null,
        }
    },

    methods: {
        async getData() {
            let res = await this.$http.get('dashboard/resellers')

            if (!res) return

            this.data = res.data
        },
    },

    mounted() {
        this.getData()
    },
}
</script>

<style lang="scss">
.no-decoration {
    text-decoration: none;
}
</style>
